import React from 'react';
import { Notification } from './';

const Dots = ({ connection }) =>
  <div className="dots">
    <div className="dot dot-1" />
    <div className="dot dot-2" />
    <div className="dot-container">
      <div className="dot dot-3" />
      <Notification connection={connection} />
    </div>
  </div>;

export default Dots;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/LockHomeDemo/components/Dots.js